<template>
  <div class="quill-editor-outer">
<!--

-->
    <quill-editor
      class="editor ql-editor"
      v-model="content"
      ref="myQuillEditor"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @change="onEditorChange($event)"
    ></quill-editor>
    <!-- 图片上传组件辅助-->
<!--    :action="serverUrl"
        :on-success="uploadSuccess"
-->
<!--    -->
    <el-upload
      class="avatar-uploader-quilleditor"
      :action="''"
      :accept="getLimitUploadImageFormat()"

      :http-request="uploadFront"
      :before-upload="beforeAvatarUpload"
      :show-file-list="false"

      :on-error="uploadError"

    ></el-upload>
<!--
:action="serverUrl"
name="file"
:headers="header"
:before-upload="beforeUpload"
-->
  </div>
</template>
<script>
import axios from 'axios';
// 工具栏配置

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用  代码块
  [{ header: 1 }, { header: 2 }], // 1、2 级标题
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  [{ script: "sub" }, { script: "super" }], // 上标/下标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  // [{'direction': 'rtl'}],                         // 文本方向
  [{ size: ["small", false, "large", "huge"] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ font: [] }], // 字体种类
  [{ align: [] }], // 对齐方式
  ["clean"], // 清除文本格式
  ["link", "image"] // 链接、图片、视频
];
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import * as Quill from "quill";
import { getLimitUploadImageFormat,limitImageSizeFormat } from '@/utils/index';

import ImageResize from "quill-image-resize-module"; // 引用
Quill.register("modules/imageResize", ImageResize); // 注册

export default {
  props: {
    /*编辑器的内容*/
    defaultValues: {
      type: String
    },
  },
  watch: {
    // 监听父组件传入的数据，更新到本地
    defaultValues(newVal, oldVal){
        this.content = newVal;
    }
  },
  components: {
    quillEditor
  },
  computed: {
    editor() {
        return this.$refs.myQuillEditor.quill;
    },
  },
  data() {
    return {
      serverUrl: process.env.VUE_APP_API + '/wx/sys/oss/upload',
      content:this.defaultValues,
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      editorOption: {
        placeholder: "",
        theme: "snow", // or 'bubble'
        // placeholder: "您想说点什么？",
        modules: {
          toolbar: {
            container: toolbarOptions,
            // container: "#toolbar",
            // handler: handlers,
            handlers: {
              image: function(value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector(".avatar-uploader-quilleditor input").click();
                } else {
                  this.quill.format("image", false);
                }
              }
            }
          },
          imageResize: {
              modules: [ 'Resize', 'DisplaySize'],
              displayStyles:{
                  backgroundColor:'black',
                  border:'none',
                  // color:'white',
              },
             displaySize: true
          }
        }
      },
    };
  },
  methods: {
    getLimitUploadImageFormat,
    onEditorReady(editor) {
      // 准备编辑器
    },
    onEditorBlur() {
      //失去焦点事件
    },
    onEditorFocus() {
      //获得焦点事件
    },
    onEditorChange() {
      // console.log(this.content);
      //内容改变事件
      this.$emit("catchData", this.content);
    },
    // 富文本图片上传前
    beforeUpload() {
      // 显示loading动画
      this.quillUpdateImg = true;
    },
    uploadFront(item){
      var formData = new FormData();
      formData.append("file", item.file);
      var finalUrl = process.env.VUE_APP_API ? process.env.VUE_APP_API + '/wx/sys/oss/upload': '/wx/sys/oss/upload'
      axios.post(finalUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          token: localStorage.getItem('token')
        }
      }).then(res => {
        this.$emit('uploaded', res.data.url)
        // resolve(data.url)
        this.handlerUploadImg(res.data.url);
      })
    },
    handlerUploadImg(imgUrl){
        let quill = this.$refs.myQuillEditor.quill;
        // 如果上传成功
        // 获取光标所在位置
        let length = quill.selection.savedRange.index;
        // let length = quill.getSelection().index;
        // 插入图片  res.data.url为服务器返回的图片地址
        quill.insertEmbed(length, "image", imgUrl);
        // 调整光标到最后
        quill.setSelection(length + 1);
    },
    uploadSuccess(res, file) {
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill;
      // 如果上传成功
      if (res.status == 10000) {
        // 获取光标所在位置
        let length = quill.selection.savedRange.index;
        // let length = quill.getSelection().index;
        // 插入图片  res.data.url为服务器返回的图片地址
        quill.insertEmbed(length, "image", res.data.content[0].url);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        this.$message.error("图片插入失败");
      }
      // loading动画消失
      this.quillUpdateImg = false;
    },
    // 富文本图片上传失败
    uploadError() {
      // loading动画消失
      this.quillUpdateImg = false;
      this.$message.error("图片插入失败");
    },
    beforeAvatarUpload(file) {
       return limitImageSizeFormat(file,this);
    },
  }
};
</script>

<style lang="scss">
.quill-editor-outer {
  .editor {
    line-height: normal !important;
    /*height: 350px;*/
  }
  .ql-snow .ql-tooltip[data-mode="link"]::before {
    content: "请输入链接地址:";
  }
  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: "保存";
    padding-right: 0px;
  }

  .ql-snow .ql-tooltip[data-mode="video"]::before {
    content: "请输入视频地址:";
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: "14px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
    content: "10px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
    content: "18px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
    content: "32px";
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: "文本";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: "标题1";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: "标题2";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: "标题3";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: "标题4";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: "标题5";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: "标题6";
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: "标准字体";
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
    content: "衬线字体";
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
    content: "等宽字体";
  }

  /*解决滚动条bug*/
  .ql-container {
    height: 480px;
  }
}

</style>
<style scoped>
.ql-editor {
  overflow-y: hidden!important;
}
.quill-editor-outer {

}
</style>
